// extracted by mini-css-extract-plugin
export default {"payment-summary-box":"CartResume_payment-summary-box__s3JFD","securePaymentInfo":"CartResume_securePaymentInfo__GPjdm"};